// Lets any page (Footer, About, ...) open the ChatBox and jump straight to
// its scheduling form, without lifting ChatBox's state up into App.js.
export const SCHEDULE_CALL_EVENT = 'eva:open-schedule';

export function openScheduleCall() {
  window.dispatchEvent(new Event(SCHEDULE_CALL_EVENT));
}
